import { useForm } from "react-hook-form"
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import CheckboxInputController from "../../components/inputs/CheckbocController";
import { useDownloadDocumentMutation } from "../../store/services/DocumentService";
import { useAcceptPrivacyMutation } from "../../store/services/PrivacyService";
import { toast } from "react-toastify";
import Loader from "../../components/main/Loader";
import { CheckIcon } from "@heroicons/react/24/outline";
import { DocumentToServer } from "../../helpers/adapter/DocumentAdapter";

interface DocumentiAziendali {
    nome: string;
    descrizione: string;
    id: number;
    aziendaId: number
}

export default function PrivacyPage({documentiAziendali}: DocumentiAziendali | any) {

    const form = useForm({ mode: "onChange" });
    const { setValue, handleSubmit, formState: { isValid }, watch } = form;
    const [downloadDocument, resultDownload] = useDownloadDocumentMutation();
    const [acceptPrivacy, resultAccept] = useAcceptPrivacyMutation();
    const navigate = useNavigate();
    const values = watch();

    const onSubmit = async (data: any) => {
        const documenti = Object.values(data);
        const result: any = await acceptPrivacy({ aziendaId: documentiAziendali[0].aziendaId, documentiAziendali: documenti });
        if ('error' in result) {
            toast.error(`Non è stato possibile inviare la richiesta! Errore: ${result?.error?.data?.detail}`)
        } else {
            navigate('/dashboard/home');
        }
    }

    const handleView = async (documento: any) => {
        const response: any = await downloadDocument({ idAzienda: documento.aziendaId, idDocument: documento.id });

        if (response?.data) {
            window.open(response.data, "_blank");
            const downloadLink = document.createElement("a");
            downloadLink.href = response.data;
            downloadLink.setAttribute("download", documento.nome || "documento.pdf");
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            setValue(`privacy-${documento.id}`, documento.id, { shouldValidate: true });
        }
    }

    return (
        <>
            {(resultDownload.isLoading || resultAccept.isLoading) && <Loader />}
            <div className="h-screen flex items-center justify-center bg-black/60">
                <form onSubmit={handleSubmit(onSubmit)} className="bg-white rounded-lg p-8 max-w-xl flex flex-col items-center gap-y-8">
                    <img src={logo} alt="logo" className="h-[80px] w-[180px]" />
                    <h3>Per continuare ad utilizzare il portale é necessario prendere visione dei seguenti documenti:</h3>

                    {
                        documentiAziendali.map((documento: DocumentToServer) => (
                            <div key={`documento-${documento.id}`} className="self-start grid grid-cols-3 gap-8">
                                <div className="col-span-2">
                                    <h4 className="font-bold text-lg">{documento.nome}</h4>
                                    <p className="tetx-base">{documento.descrizione}</p>
                                    <span 
                                        className={`text-base mt-2 
                                        ${values && Object.values(values).includes(documento.id) ? 'text-green-600 font-semibold' : 'text-blue-600'}
                                        cursor-pointer flex items-center`} onClick={() => handleView(documento)}>
                                    {values && Object.values(values).includes(documento.id) && <CheckIcon className="w-5 h-5 mr-2" />}
                                    {values && Object.values(values).includes(documento.id) ? 'Hai preso visione del documento' : 'Visualizza e prendi visione'} 
                                    </span>
                                </div>
                                <CheckboxInputController
                                    input={{
                                        name: `privacy-${documento.id}`,
                                        validators: { required: 'Il campo è richiesto' },
                                        value: documento.id!
                                    }}
                                    isDisabled={true}
                                    form={form}
                                />
                            </div>
                        ))
                    }

                    <div className="flex items-center justify-end">
                        <button
                            disabled={!isValid}
                            className={`h-10 bg-[#064e3b] w-32 text-white px-2 inlie rounded-lg text-md ${!isValid && 'opacity-70'}`}
                        >Conferma</button>
                    </div>
                </form>
            </div>
        </>
    )
}
